import { createDynamicContext } from 'js/store/helpers';

import * as Types from './types';
import * as reducer from './reducer';

export const {
    withDynamicReducer,
    useDynamicReducerSelector,
    useDynamicReducerDispatch
} = createDynamicContext<Types.IChangeFormState, Types.TChangeFormAction>('changeForm', reducer);
